const Banner = {

    init() {
        this.el = $('[module="banner"]');
        if (!this.el.length) return;
        const sections = this.el.find('> section');
        this.video = this.el.find('[element="image"] video');

        if(sections.length < 2) {
            this.el.addClass('single');
        }
        this.resize();
        this.bind();
    },

    bind() {
        this.el.addClass('owl-carousel');
        this.el.owlCarousel({
            "smartSpeed": 1500,
            "loop": true,
            "autoWidth": false,
            "nav": true,
            "dots": true,
            "progress": true,
            "counter": false,
            "margin": 0,
            "stagePadding": 0,
            "items": 1,
            "navText": ["", ""]
        });
    },

    resize(){
        if (!this.el.length || !this.video.length) return;

        if(this.video.outerHeight() < this.el.innerHeight()){
            this.video.addClass('portrait');
        }
        if(this.video.outerWidth() < this.el.innerWidth()){
            this.video.removeClass('portrait');
        }
    }
}

export default Banner;